module.exports = __webpack_public_path__ + "img/clock.565fe25f.svg";